<template>
  <section class="cover-page">
    <img class="cover-background" :src="coverImage" alt="中医体质辨识报告封面" />

    <svg
      class="cover-overlay"
      viewBox="0 0 2480 3508"
      preserveAspectRatio="none"
      role="img"
      aria-label="报告基本信息"
    >
      <g
        class="cover-values"
        text-anchor="middle"
        dominant-baseline="central"
      >
        <text
          v-if="hasValue(report.userName)"
          x="1450"
          y="1892"
          font-size="56"
        >{{ report.userName }}</text>
        <text
          v-if="hasValue(report.age)"
          x="1450"
          y="2089"
          font-size="56"
        >{{ report.age }}</text>
        <text
          v-if="hasValue(report.gender)"
          x="1450"
          y="2285"
          font-size="56"
        >{{ report.gender }}</text>
        <text
          v-if="hasValue(report.mobile)"
          x="1450"
          y="2481"
          font-size="56"
        >{{ report.mobile }}</text>
        <text
          v-if="reportDate"
          x="1450"
          y="2676"
          font-size="56"
        >{{ reportDate }}</text>
        <text
          v-if="reportNumber"
          x="1450"
          y="2872"
          font-size="56"
        >{{ reportNumber }}</text>
        <text
          v-if="hasValue(deviceId)"
          x="1450"
          y="3069"
          font-size="56"
        >{{ deviceId }}</text>
      </g>
    </svg>
  </section>
</template>

<script>
import {
  formatReportDate,
  isValidValue,
  REPORT_BRAND_NAME,
} from '../helpers';
import { REPORT_ASSETS } from '../reportAssets';

export default {
  name: 'CoverPage',
  props: {
    report: {
      type: Object,
      default: () => ({}),
    },
    brandName: {
      type: String,
      default: REPORT_BRAND_NAME,
    },
  },
  data() {
    return {
      coverImage: REPORT_ASSETS.cover,
    };
  },
  computed: {
    reportDate() {
      return formatReportDate(
        this.report.detectTime
          || this.report.createAt
          || this.report.createTime,
      );
    },
    reportNumber() {
      return this.report.reportId || this.report.id || '';
    },
    deviceId() {
      const { inputParams } = this.report;
      return this.report.deviceId
        || this.report.equipmentId
        || (
          inputParams
          && typeof inputParams === 'object'
          && inputParams.imei
        )
        || '';
    },
  },
  methods: {
    hasValue(value) {
      return isValidValue(value);
    },
  },
};
</script>

<style lang="scss" scoped>
.cover-page {
  position: relative;
  width: 100%;
  min-height: 0;
  aspect-ratio: 210 / 297;
  overflow: hidden;
  background: #f8ead5;
  isolation: isolate;
}

.cover-background,
.cover-overlay {
  position: absolute;
  inset: 0;
  display: block;
  width: 100%;
  height: 100%;
}

.cover-background {
  z-index: 0;
  object-fit: fill;
}

.cover-overlay {
  z-index: 1;
  pointer-events: none;
}

.cover-values {
  fill: #68311d;
  font-family: "Source Han Sans SC", "Source Han Sans CN", "Noto Sans CJK SC",
    "PingFang SC", "Microsoft YaHei", sans-serif;
  font-weight: 700;
}
</style>
